const getLedgerQuery = `
select * from avocado.get_ledger ($1, $2);
`
module.exports = getLedgerQuery
